type PageObject = {
  name: string
  description: string
}

type ImpactModulePages = {
  [key: string]: PageObject
}

export const INSTITUTIONAL_MANAGEMENT_PAGES: ImpactModulePages = {
  BOND: {
    name: 'Solicitações de vínculos',
    description: 'Gestão das solicitações de vínculo da instituição',
  },
  CONTRACT_TYPE: {
    name: 'Tipos de contratos do profissional',
    description: 'Gestão dos tipos de contratos do profissional da instituição',
  },
  ACTIVITY_TYPE: {
    name: 'Tipos de atividades',
    description: 'Gestão dos tipos de atividades',
  },
  BOND_OPTION: {
    name: 'Vínculo',
    description: 'Gestão do vínculo da instituição',
  },
  CITIZEN: {
    name: 'Cidadãos',
    description: 'Gestão dos cidadãos',
  },
  GROUP: {
    name: 'Grupos',
    description: 'Gestão dos grupos de agentes',
  },
  GROUP_MODULE_PERMISSION: {
    name: 'Permissões de grupos',
    description: 'Gestão das permissões dos grupo',
  },
  ORGANIZATIONAL_UNIT: {
    name: 'Unidades organizacionais',
    description: 'Gestão das unidades organizacionais',
  },
  MODULE: {
    name: 'Módulos',
    description: 'Gestão dos módulos da instituição',
  },
  SALARY: {
    name: 'Salários',
    description: 'Gestão dos salários',
  },
  SYSTEM: {
    name: 'Sistemas',
    description: 'Gestão dos sistemas',
  },
  PUBLIC_AGENT: {
    name: 'Agentes públicos',
    description: 'Gestão dos agentes públicos',
  },
  PUBLIC_AGENT_MODULE_PERMISSION: {
    name: 'Permissões dos agentes',
    description: 'Gestão das permissões dos agentes públicos',
  },
  BENEFIT: {
    name: 'Benefícios',
    description: 'Gestão dos benefícios',
  },
  JOBSITE: {
    name: 'Postos de trabalho',
    description: 'Gestão dos postos de trabalho',
  },
  COST_CENTER: {
    name: 'Centros de custo',
    description: 'Gestão dos centros de custos',
  },
}
